import { Calendar } from '@fullcalendar/core'
import timeGridPlugin from '@fullcalendar/timegrid'
import czLocale from '@fullcalendar/core/locales/cs';
import interactionPlugin, { Draggable } from '@fullcalendar/interaction';
//https://github.com/CodeSeven/toastr
import toastr from 'toastr';

export class DayShifts {
	constructor() {
		this._calendar = null;
		this._renderingFinishedCallback = null;

		let $calendar = $('#day-shifts-calendar');
		if ($calendar.length > 0) {
			this.initCalendar($calendar);
		}

		this.initButtons();
	}

	//=====================================================================
	// Controls section
	//=====================================================================

	initButtons() {
		let $document = $(document),
			app = this;
		
		$document.on('click', '.sheriff-row .presence-icon', function (e) {
			if ($(this).hasClass('is-present-present'))
			{
				app.absenceReasonEdit($(this));
			}
			app.changeSheriffPresence($(this));
		});

		$document.on('click', '.absence-reason', function () {
			app.absenceReasonEdit($(this));
		});

		$document.on('click', '.sheriff-row .camera-icon', function (e) {
			app.setSheriffDeviceNumber($(this), 'camera');
		});
		
		$document.on('click', '.sheriff-row .radio-icon', function (e) {
			app.setSheriffDeviceNumber($(this), 'radio');
		});
		
		$document.on('click', '.fc-event-copy', function (e) {
			e.preventDefault();
			let eventId = parseInt($(this).closest('.fc-timegrid-event-harness').find('.fc-event').data('eventId'));
			app.copyDayShiftDialog(eventId);
		});
		$document.on('click', '.fc-event-remove', function (e) {
			e.preventDefault();
			let eventId = parseInt($(this).closest('.fc-timegrid-event-harness').find('.fc-event').data('eventId'));
			app.removeShift(eventId, null);
		});
	}
	
	initCalendar ($calendar) {
		var app = this,
			calendarEl = $calendar.get(0),
			initialDate = Cookies.get('dayShifts--calendar-initial-date'),
			options = {
				plugins: [timeGridPlugin, interactionPlugin],
				initialView: 'timeGridWeek',
				locales: [ czLocale ],
				locale: 'cs',
				headerToolbar: {
					left: 'prev,next',
					center: 'title',
					right: 'timeGridWeek,timeGridDay' // user can switch between the two
				},
				height: "auto",
				allDaySlot: false,
				events: route('dayShifts.getData', {}),
				editable: true,
				eventStartEditable: true,
				eventResizableFromStart: true,
				eventDurationEditable: true,
				droppable: true,
				eventDrop: app.eventTimeEdit,
				eventResize: app.eventTimeEdit,
				eventClick: app.eventEdit,
				eventReceive: app.eventReceive,
				datesSet: app.dateChanged,
				eventDidMount: app.eventMount,
			};
		
		if (initialDate) {
			options.initialDate = initialDate;
			Cookies.remove('dayShifts--calendar-initial-date');
		}
		
		const calendar = new Calendar(calendarEl, options);
		calendar.render();
		app._calendar = calendar;

		$('#shift-templates-table .fc-event-draggable').each(function (i, el) {
			var $el = $(el);
			new Draggable(el, {
				eventData: {
					title: $el.data('shiftName'),
					duration: $el.data('shiftDuration'),
				}
			});
		});

		//Schedule stats reload
		window.setTimeout(app.reloadStats, 100);
	}

	//=====================================================================
	// Calendar methods
	//=====================================================================

	saveDayShift (event, data, dialog) {
		let app = this,
			eventId = event.id;
		
		$.ajax({
			url: route('dayShifts.update', {'dayShift': eventId}),
			method: 'put',
			dataType: 'json',
			data: data,
			success: function (result) {
				let message = $Lang.shifts.updateSuccess;
				if ('message' in result) {
					message = result.message;
				}
				toastr.success(message);
				
				dialog.modal('hide');

				app.reloadStats();
			},
			error: function (result) {
				dialog.modal('hide');
				app.processError(result, $Lang.shifts.shiftEditFailException);
			},
		});
		
	}

	initEditDialog (dialog, result, event) {
		let app = this;
		
		dialog.find('.bootbox-body').html(result);
		dialog.find('button.js-remove-shift').on('click',  function (e) {
			e.preventDefault();
			app.removeShift(event.id, dialog);
		});
		dialog.find('.js-whisperer-select').each(function (i, el) {
			window.$whisperers.initSelect($(el), dialog);
		});
	}
	
	saveDayShiftForm (event, dialog) {
		let app = this,
			eventId = event.id,
			data = dialog.find('form').serializeArray();
		data.push({name: 'fullForm', value: true});

		$.ajax({
			url: route('dayShifts.update', {'dayShift': eventId}),
			method: 'put',
			dataType: 'json',
			data: data,
			success: function (result) {
				let message = $Lang.shifts.updateSuccess;
				if ('message' in result) {
					message = result.message;
				}
				toastr.success(message);
				dialog.modal('hide');

				if (('refresh' in result) && result.refresh) {
					bootbox.alert({
						message: $Lang.shifts.awaitReload,
						closeButton: false,
					});
					Cookies.set('dayShifts--calendar-initial-date', app._calendar.getDate().toISOString());
					window.location.reload();
				}
				else
				{
					app.reloadStats();
				}
			},
			error: function (result) {
				if ('errors' in result.responseJSON) {
					inputErrors = result.responseJSON.errors;
					$customs.checkErrors();
				}

				app.processError(result, null);
			},
		});

		event.setProp('borderColor', event.backgroundColor);
	}

	//-------------------------------------------------------------------------
	
	eventEdit (eventClickInfo) {

		let event = eventClickInfo.event;
		event.setProp('borderColor', "#FF0000");
		
		let app = window.$dayShifts,
			eventId = event.id,
			
			dialog = bootbox.dialog({
				title: $Lang.shifts.editDayShiftTitle,
				message: '<p><i class="fas fa-spin fa-spinner"></i>'+$Lang.common.loading+'</p>',
				size: 'large',
				buttons: {
					copy: {
						label: $Lang.shifts.copyDayShiftButton,
						className: 'btn-info pull-left',
						callback: function(){
							app.copyDayShiftDialog(event.id);
							event.setProp('borderColor', event.backgroundColor);
							return false;
						}
					},
					cancel: {
						label: $Lang.common.cancel,
						className: 'btn-danger',
						callback: function(){
							event.setProp('borderColor', event.backgroundColor);
						}
					},
					ok: {
						label: $Lang.common.save,
						className: 'btn-success',
						callback: function() {
							app.saveDayShiftForm(event, dialog);
							return false;
						}
					}
				},
				onEscape: function() {
					event.setProp('borderColor', event.backgroundColor);
				}
			});

		dialog.init(function() {
			$.ajax({
				url: route('dayShifts.edit', {'dayShift': eventId}),
				method: 'get',
				success: function (result) {
					app.initEditDialog(dialog, result, event);
				},
				error: function (result) {
					dialog.modal('hide');
					event.setProp('borderColor', event.backgroundColor);

					app.processError(result, $Lang.shifts.shiftEditFailException);
				},
			});
		});
	}
	
	eventTimeEdit (eventResizeInfo) {
		
		let dialog = bootbox.dialog({
			title: $Lang.shifts.editDayShiftTitle,
			message: '<p><i class="fas fa-spin fa-spinner"></i>'+$Lang.common.loading+'</p>',
			closeButton: false,
		});
		
		let app = window.$dayShifts,
			event = eventResizeInfo.event,
			data = {
				timeStart: eventResizeInfo.event.startStr,
				timeEnd: eventResizeInfo.event.endStr,
			};
		app.saveDayShift(event, data, dialog);
	}

	eventReceive (eventInfo) {
		var app = window.$dayShifts,
			$template = $(eventInfo.draggedEl),
			shiftId = $template.data('shiftId');
		eventInfo.event.setProp('backgroundColor', $template.data('shiftColor'));
		eventInfo.event.setProp('borderColor', $template.data('shiftColor'));
		
		$.ajax({
			url: route('dayShifts.store', {}),
			dataType: 'json',
			method: 'post',
			data: {
				shiftId: shiftId,
				timeStart: eventInfo.event.startStr,
				timeEnd: eventInfo.event.endStr,
			},
			success: function (result) {
				let message = $Lang.shifts.createSuccess;
				if ('message' in result) {
					message = result.message;
				}
				if ('id' in result) {
					eventInfo.event.setProp('id', result.id);
					$('.fc-event').each(function (i, el) {
						let $el = $(el);
						if ($el.data('attrSet') !== 'true') {
							eventInfo.el = el;
							app.eventMount(eventInfo);
							
						}
					});
				}
				toastr.success(message);
				
				app.reloadStats();
			},
			error: function (result) {
				app.processError(result, $Lang.shifts.shiftCreateFailException);
				eventInfo.event.remove();
			},
		});
	}
	
	eventMount (eventInfo) {
		let $el = $(eventInfo.el),
			$event = $el.closest('.fc-event');
		
		if (($event.data('attrSet') !== 'true') && eventInfo.event.id) {
			$el.data('eventId', eventInfo.event.id);
			$event.data('attrSet', 'true');
			let $icon = $el.closest('.fc-event.day-shift').hasClass('shift-day')
				? $('<i class="fas fa-sun"></i>')
				: $('<i class="fas fa-moon"></i>'),
				$buttons = $('<div class="buttons-container">' +
					'<button class="btn btn-default btn-circle btn-outline fc-event-copy"><i class="fas fa-copy"></i></button>' +
					'<button class="btn btn-default btn-circle btn-outline fc-event-remove ml-5"><i class="fas fa-trash-alt"></i></button>' +
					'</div>');
			$el.find('.fc-event-title-container').append($icon);
			$el.closest('.fc-timegrid-event-harness').append($buttons);
		}
	}
	
	//-------------------------------------------------------------------------

	/**
	 * 
	 * @param eventId
	 */
	copyDayShiftDialog (eventId) {
		let app = this,
			event = app._calendar.getEventById(eventId),
			message = "",
			d = new Date(event.end.getFullYear(), (event.end.getMonth() + 1) % 12, 0);
		
		message += "<div id='copy-day-shift-properties-form'>";
		message += "<div class='loading-animation'></div>";
		message += "<div class='form-group'>" +
			"<label for='copy-shift-pattern-select'>" + $Lang.shifts.copyDialogPatternLabel + "</label>" +
			"<select class='form-control' id='copy-shift-pattern-select'>";
		$.each($Lang.shifts.copyPatterns, function (i, e) {
			message += "<option value='" + i + "'>" + e + "</option>";
		});
		message += "</select></div>";

		message += "<div class='form-group'><label for='copy-shift-end-date'>" + $Lang.shifts.copyDialogEndDateLabel + "</label>" +
			"<input class='form-control' id='copy-shift-end-date' type='text' value='" + formatDate(d) + "'>";
		
		message += "</div></div>";

		bootbox.dialog({
			title: $Lang.shifts.copyDialogTitle,
			message: message,
			buttons: {
				ok: {
					label: $Lang.common.ok,
					className: 'btn-success',
					callback: function () {
						app.copyDayShiftConfirmed(event);
						return false;
					}
				},
				cancel: {
					label: $Lang.common.cancel,
					className: 'btn-danger pull-left'
				}
			},
		});
	}

	copyDayShiftConfirmed(event) {
		let app = this,
			$form = $('#copy-day-shift-properties-form'),
			$dateInput = $form.find('#copy-shift-end-date'),
			pattern = $form.find('#copy-shift-pattern-select').val(),
			endDate = $dateInput.val();
		$('.loading-animation').show();

		$.ajax({
			url: route('dayShifts.copy', { dayShift: event.id }),
			dataType: 'json',
			method: 'post',
			timeout: 60000,
			data: {
				pattern: pattern,
				endDate: endDate,
			},
			success: function (result) {
				if (result) {
					Cookies.set('dayShifts--calendar-initial-date', app._calendar.getDate().toISOString());
					window.location.reload();
				} else {
					$('.loading-animation').hide();
					//TODO zobrazit neznamou chybu
				}
			},
			error: function (result) {
				$('.loading-animation').hide();
				//TODO pokud existuje result.responseJSON.errors, tak je zobrazit ve formulari
				app.processError(result, null);
			},
		});
		/*
		if (endDate.match(/^\d{1,2}\.\d{1,2}\.\d{4}/)) {
			$dateInput.parent().removeClass('has-error');
			console.log(pattern, endDate);
			return true;
		} else {
			$dateInput.parent().addClass('has-error');
		}*/
	}

	//-------------------------------------------------------------------------

	/**
	 * 
	 * @param eventId
	 * @param dialog
	 */
	removeShift (eventId, dialog) {
		let app = window.$dayShifts,
			skipConfirm = (Cookies.get('dayShifts--skip-confirm-remove') === 'true');
		if (skipConfirm) {
			app.removeShiftConfirmed(eventId, dialog);
		} else {
			bootbox.dialog({
				message: $Lang.shifts.deleteDayShiftConfirm,
				title: $Lang.shifts.deleteDayShiftConfirmTitle,
				buttons: {
					confirmForever: {
						label: $Lang.shifts.confirmAndDontAsk,
						className: 'btn-warning',
						callback: function () {
							Cookies.set('dayShifts--skip-confirm-remove', 'true');
							app.removeShiftConfirmed(eventId, dialog);
						}
					},
					confirm: {
						label: $Lang.common.yes,
						className: 'btn-success',
						callback: function () {
							app.removeShiftConfirmed(eventId, dialog);
						}
					},
					cancel: {
						label: $Lang.common.cancel,
						className: 'btn-danger pull-left'
					}
				},
			});
		}
		
	}

	/**
	 * 
	 * @param eventId
	 * @param dialog
	 */
	removeShiftConfirmed (eventId, dialog) {
		let app = this,
			url = route('dayShifts.destroy', { dayShift: eventId });
		
		$.ajax({
			url: url,
			method: 'delete',
			success: function (result) {
				let message = $Lang.shifts.deleteSuccess;
				if ('message' in result) {
					message = result.message;
				}
				toastr.success(message);
				if (dialog) {
					dialog.modal('hide');
				}
				let event = app._calendar.getEventById(eventId);
				if (event) {
					event.remove();
				}

				app.reloadStats();
			},
			error: function (result) {
				app.processError(result, null);
			},
		});
	}

	//-------------------------------------------------------------------------

	reloadStats () {
		var app = window.$dayShifts,
			calendar = app._calendar;
		
		$.ajax({
			url: route('dayShifts.getStats', {}),
			dataType: 'json',
			method: 'get',
			data: {
				currentDate: calendar.getDate().toISOString(),
			},
			success: function (result) {
				$.each(result, function (shiftId, data) {
					let $table = $('#shift-'+shiftId+'-params');
					$table.find('td.week-hours').text(data.w);
					$table.find('td.month-hours').text(data.m);
				});
			},
			error: function (result) {
				app.processError(result, null);
			},
		});
	}

	dateChanged (e) {
		let app = window.$dayShifts;
		if (app) {
			app.reloadStats();
			Cookies.set('dayShifts--calendar-initial-date', app._calendar.getDate().toISOString());
		}
	}

	//=====================================================================
	// Header methods
	//=====================================================================
	
	sendAttrChangeRequest ( dayShiftSheriffId, data, callback ) {
		let app = this;
		
		$.ajax({
			url: route('dayShifts.setAttr', {'sheriff': dayShiftSheriffId}),
			dataType: 'json',
			method: 'post',
			data: data,
			success: callback,
			error: function (result) {
				app.processError(result, null);
			},
		});
	}
	
	changeSheriffPresence ($button) {
		let app = this,
			$row = $button.closest('.sheriff-row'),
			dayShiftSheriffId = $row.data('id'),
			presenceButtonSpan = $button.closest('.is-present-field');
		
		app.sendAttrChangeRequest(
			dayShiftSheriffId,
			{
				attr: 'is_present',
				val: null,
			}, 
			function (result) {
				if ('message' in result) {
					toastr.success(result.message);
				}
	
				if ('is_present' in result) {
					$row.attr('class', "sheriff-row presence-state-" + result.is_present);
					presenceButtonSpan.attr('data-original-title', $Lang.sheriffs.presence[result.is_present]);

					if (result.is_present !== "absent") {
						$row.find('.absence-reason').addClass('hidden')
					}
					else {
						$row.find('.absence-reason').removeClass('hidden')
					}
				}
		});
	}

	setSheriffDeviceNumber ($button, device) {
		let app = this,
			$row = $button.closest('.sheriff-row'),
			$valSpan = $button.find('.val'),
			currentNumber = $valSpan.text().trim(),
			dayShiftSheriffId = $row.data('id');

		bootbox.prompt({
			title: $Lang.sheriffs[device + 'Number'],
			value: [currentNumber],
			inputType: 'number',
			callback: function (result) {
				if (result !== null)
				{
					app.sendAttrChangeRequest(
						dayShiftSheriffId,
						{
							attr: device,
							val: result,
						},
						function (result) {
							if ('message' in result) {
								toastr.success(result.message);
							}

							if (device in result) {
								$valSpan.text(result[device]);
							}
						});
				}
			}
		});
	}

	absenceReasonEdit ($button) {
		let app = this,
			lang = $Lang.sheriffs,
			$row = $button.closest('.sheriff-row'),
			dayShiftSheriffId = $row.data('id'),
			span = $row.find('.absence-reason');

		bootbox.prompt({
			title: lang.absenceReason,
			value: [span.text().trim()],
			inputType: 'textarea',
			callback: function (result) {
				if (result !== null)
				{
					app.sendAttrChangeRequest(
						dayShiftSheriffId,
						{
							attr: 'absence_reason',
							val: result,
						},
						function (result) {
							if ('message' in result) {
								toastr.success(result.message);
							}

							if ('absence_reason' in result) {
								span.text(result.absence_reason);
							}
						}
					);
				}
			}
		});
	}

	//=====================================================================
	// Helpers
	//=====================================================================

	/**
	 * 
	 * @param result: object
	 * @param bootboxMessageTitle: string|null
	 */
	processError (result, bootboxMessageTitle) {
		console.error(result);
		
		let message = $Lang.common.unknownException;
		if ('responseJSON' in result && result.responseJSON && 'message' in result.responseJSON)
		{
			message = result.responseJSON.message;
		}
		
		if (bootboxMessageTitle) {
			bootbox.alert({
				title: bootboxMessageTitle,
				message: '<p>'+message+'</p>',
			});
		} else {
			toastr.error(message);
		}
		
	}
	
}


if (!window.$dayShifts) {
	window.$dayShifts = new DayShifts();
}
